<template>
  <div>
    <b-button id="show-btn" variant="primary" @click="showModal">Alterar Métricas</b-button>
    
    <b-modal size="md" ref="my-modal" hide-footer centered title="Alteração de Métricas" @hidden="clearInputs">
      <div class="d-block text-center">
        <b-form-select class="inputs" v-model="gateway" :options="gateways"></b-form-select>
        <b-form-select class="inputs" v-model="quantity" :options="filteredOptions"></b-form-select>
        
        <b-form-input 
          class="inputs" 
          v-model="text" 
          placeholder="Insira o novo valor..." 
          @input="replace" 
          @keyup.enter="updateMetrics"
        ></b-form-input>

        <div class="d-flex justify-content-center">
          <b-button class="btn-save" variant="primary" block @click="updateMetrics">
            Salvar
          </b-button>
        </div>
      </div>
    </b-modal> 
  </div>
</template>

<script>
import { BButton, BFormSelect, BFormInput } from "bootstrap-vue";
import GatewayExpenseService from "@/service/gateway-expense"

export default {
  name: 'UpdateMetrics',
  components: { BButton, BFormSelect, BFormInput },
  data() {
    return {
      gateway: null,
      gateways: [],
      quantity: null,
      options: {},
      text: '',
      isLoading: false
    };
  },
  computed: {
    filteredOptions() {
      if (this.gateway && this.options[this.gateway]) {
        return [
          { value: null, text: 'Selecione a quantidade...' },
          ...this.options[this.gateway].map(item => ({
            value: item.quantity,
            text: `Quantidade: ${item.quantity} - Valor atual: ${item.value}`
          }))
        ];
      }
      return [{ value: null, text: 'Selecione a quantidade...' }];
    },
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.isLoading = true;
      try {
        const response = await GatewayExpenseService.getMetrics();
        const data = response?.data || response;

        this.gateways = [
          { value: null, text: 'Selecione o gateway...' },  
          ...Object.keys(data).map(key => ({
            value: key,
            text: key.toUpperCase(),  
          }))
        ];
        this.options = { ...data };  
      } catch (error) {
        console.error('Erro ao buscar dados da API:', error);
      } finally {
        this.isLoading = false;
      }
    },

    showModal() {
      this.$refs['my-modal'].show();
    },
    hideModal() {
      this.$refs['my-modal'].hide();
    },

    async updateMetrics() {
      if (!this.gateway || !this.quantity || !this.text) {
        this.modal('Por favor, preencha todos os campos!');
        return;
      }

      try {
        const response = await GatewayExpenseService.updateMetrics({
          gateway: this.gateway,
          metrics: {
            quantity: this.quantity,
            value: this.text,
          }
        });

        this.modal('Métricas atualizadas com sucesso!');
        this.hideModal();
        
        this.$emit('refresh'); 

      } catch (error) {
        console.error("Erro ao atualizar as métricas:", error);
        this.modal('Ocorreu um erro ao atualizar as métricas.');
      }
    },

    replace() {
      this.text = this.text.replace(',', '.');
    },

    clearInputs() {
      this.gateway = null;
      this.quantity = null;
      this.text = '';
    }
  }
};
</script>

<style scoped>
.inputs {
  margin-bottom: 20px;
  margin-top: 10px;
  border: 1px solid #2e2c6c;
}
.btn-save {
  width: 30%;
  margin-bottom: 10px;
  font-weight: bold; 
}

 .modal-header, .modal-title {
  color: white; 
  background-color: #2e2c6c !important; 
  font-weight: bold; 
}
</style>